import { render, staticRenderFns } from "./KucunForm.vue?vue&type=template&id=01e14d1e&"
import script from "./KucunForm.vue?vue&type=script&lang=js&"
export * from "./KucunForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports